import styled from 'styled-components';
import {
  mobile_width_percentage,
  tablet_breakpoint,
  tablet_container_maxwidth,
  tablet_portrait_breakpoint,
  desktop_breakpoint_extended,
  desktop_container_maxwidth,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const EmailSignupStdStyles = styled.div`
  .modal-container {
    background-color: #ffffff;
    text-align: center;
    width: ${mobile_width_percentage}%;
  }
  .modal-content {
    display: flex;
    overflow: hidden;
  }
  .email-image {
    display: none;
  }
  .email-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 20px auto;
    width: 100%;
    svg {
      height: 30px;
      width: 30px;
      path {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }
    h1 {
      font-family: 'acumin-pro';
      font-size: 21px;
      font-weight: 700;
      margin: -5px 30px 10px 30px;
    }
    h4 {
      color: #4c4c4c;
      font-family: 'source-sans-pro';
      font-size: 13.5px;
      font-weight: 400;
      margin: -7px 20px 15px 20px;
      padding-bottom: 20px;
    }
    a {
      border-radius: 4px;
      font-family: 'source-sans-pro';
      font-size: 8px;
      font-weight: 600;
      height: 30px;
      margin: auto;
      padding: 9px;
      width: 115px;
    }
    p {
      font-family: 'source-sans-pro';
      font-size: 6.5px;
      font-weight: 600;
      padding-top: 15px;
      text-transform: uppercase;
      max-width: 75%;
    }
  }

  .webform-container {
    width: 80%;

    .button {
      margin: 0 auto;
    }
  }

  /*Mobile View (LG)*/
  @media screen and (min-width: ${tablet_breakpoint}px) {
    .email-content {
      svg {
        height: 35px;
        width: 35px;
      }
      h1 {
        font-size: 23px;
      }
      h4 {
        font-size: 15px;
      }
      a {
        height: 35px;
        font-size: 9px;
        padding: 10px;
        width: 130px;
      }
      p {
        font-size: 8px;
      }
    }
  }

  /*Tablet View (SM)*/
  @media screen and (min-width: ${tablet_container_maxwidth}px) {
    .modal-container {
      padding: 30px 30px 0;
    }
    .modal-content {
      flex-direction: column;
    }
    .email-image {
      display: flex;
      background-position: 50% 80%;
      background-repeat: no-repeat;
      background-size: cover;
      height: 340px;
      min-height: 80px;
    }

    .email-content {
      svg {
        height: 40px;
        width: 40px;
      }
      h1 {
        font-size: 30px;
        margin: 0 50px 20px 50px;
      }
      h4 {
        font-size: 18px;
        margin: -10px 50px 25px 50px;
      }
      a {
        font-size: 13px;
        height: 37.5px;
        padding: 9px;
        width: 160px;
      }
      p {
        font-size: 10.5px;
      }
    }
  }

  /*Tablet View (LG)*/
  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .email-content {
      svg {
        height: 25px;
        width: 25px;
      }
      h1 {
        font-size: 22px;
        margin: 0 40px 20px 40px;
      }
      h4 {
        font-size: 15px;
        margin: -10px 20px 25px 20px;
      }
      a {
        font-size: 12px;
        height: 32px;
        padding: 8.5px;
        width: 125px;
      }
      p {
        font-size: 8.5px;
      }
    }
  }

  /*Laptop View*/
  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .modal-container {
      padding: 0;
      width: 850px;
    }
    .modal-content {
      flex-direction: row;
    }
    .email-image {
      float: left;
      height: auto;
      width: 100%;
    }
    .email-content {
      margin: 75px 0;
      svg {
        height: 38px;
        width: 38px;
      }
      h1 {
        font-size: 35px;
      }
      h4 {
        font-size: 21px;
      }
      a {
        font-size: 15px;
        height: 39px;
        width: 180px;
      }
      p {
        font-size: 9.5px;
      }
    }
  }

  /*Desktop View*/
  @media screen and (min-width: ${desktop_container_maxwidth}px) {
    .modal-container {
      width: 1250px;
    }
    .email-content {
      margin: 100px 0;
      svg {
        height: 42px;
        width: 42px;
      }
      h1 {
        font-size: 51px;
      }
      h4 {
        font-size: 27px;
        margin: 0 55px 40px 55px;
      }
      a {
        font-size: 15px;
        height: 60px;
        padding: 19px;
        width: 240px;
      }
      p {
        font-size: 10.5px;
      }
    }

    .webform-container {
      max-width: 386px;

      .button {
        padding-left: 80px;
        padding-right: 80px;
      }
    }
  }
`;
